const INSTALLATION = 'installation';
const OTHER_EXPENSE = 'other-expense';

export { INSTALLATION, OTHER_EXPENSE };
